import { useState, useEffect, useRef } from 'react';
import { IonModal, IonButton, IonIcon, IonInput, IonRange, IonLabel, IonList, IonItem, IonCheckbox, IonImg } from '@ionic/react';
import { star, close } from 'ionicons/icons';
import { PriceHotelsLimit, HotelStars } from '../../../defines/Functions';
import Loading from '../../Loading';
import HotelMap from './HotelMap';
import CurrencyFormat from 'react-currency-format';
import hotelFilterMap from '../../../assets/images/filter-map.jpg';
import './HotelFilter.css';
import filterImg from '../../../assets/images/filter-filter.svg';

interface Props {
    data: any,
    dataAlt?: any,
    hotelFilterParentCallback: Function,
    filters: any,
    disabled?: boolean,
    codeParentCallback: Function,
    type?: string
}
const HotelFilter = (item: Props) => {
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showHotelFilterModal: false,
        hotelPrice: {
            min: 0 as number,
            max: 0 as number,
            lower: 0 as number,
            upper: 0 as number
        },
        hotelRate: [] as any,
        searchKeyword: '' as any
    });
    const mapData = useRef<any>([]);
    useEffect(() => {
        if (state.showHotelFilterModal) {
            if (item.data && item.dataAlt.hotelStays) {
                let isPriceFilter = false;
                const priceLimit = PriceHotelsLimit(item.dataAlt.hotelStays.hotelStay);
                let hotelRateArr = [] as any;
                HotelStars(item.dataAlt.hotelStays.hotelStay).forEach(starItem => {
                    let checked = false;
                    let index = item.filters.hotelRate.findIndex((x: any) => x.value === starItem);
                    if (index !== -1) {
                        checked = true;
                    }
                    hotelRateArr.push({ value: starItem, checked: checked });
                });
                if (item.type !== 'flightHotel') {
                    if (item.filters.hotelPrice.lower !== 0 || item.filters.hotelPrice.upper !== 0) {
                        priceLimit.min = item.filters.hotelPrice.lower;
                        priceLimit.max = item.filters.hotelPrice.upper;
                        isPriceFilter = true;
                    }
                    setTimeout(() => {
                        const priceRangeEl: any = document.querySelector('#priceRange');
                        priceRangeEl.value = { lower: priceLimit.min, upper: priceLimit.max };
                    }, 100);
                    let myRangeMinMax = {
                        hotelPrice: {
                            min: priceLimit.min,
                            max: priceLimit.max
                        }
                    };
                    if (isPriceFilter) {
                        myRangeMinMax.hotelPrice.min = state.hotelPrice.min;
                        myRangeMinMax.hotelPrice.max = state.hotelPrice.max;
                    }
                    setState({
                        ...state,
                        hotelPrice: { lower: priceLimit.min, upper: priceLimit.max, min: myRangeMinMax.hotelPrice.min, max: myRangeMinMax.hotelPrice.max },
                        hotelRate: hotelRateArr
                    });
                } else {
                    setState({
                        ...state,
                        hotelPrice: { lower: 0, upper: 0, min: 0, max: 0 },
                        hotelRate: hotelRateArr
                    });
                }
            }
            let mapDataTemp = [] as any;
            item.data.forEach((item: any) => {
                mapDataTemp.push(item);
            })
            mapData.current = mapDataTemp;
        }
        setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.showHotelFilterModal]);
    const checkAll = (querySelector: string) => {
        document.querySelectorAll('.' + querySelector + ' ion-checkbox').forEach((item: any) => {
            if (!item.checked) {
                item.checked = true;
            }
        })
    }
    const unCheckAll = (querySelector: string) => {
        document.querySelectorAll('.' + querySelector + ' ion-checkbox').forEach((item: any) => {
            if (item.checked) {
                item.checked = false;
            }
        })
    }
    const checkCheckbox = (index: number, value: boolean) => {
        let checkboxItems = [] as any;
        checkboxItems = state.hotelRate;
        checkboxItems[index].checked = value;
        setState({ ...state, hotelRate: checkboxItems });
    }
    const setRangeSlider = (value: any) => {
        setState({ ...state, hotelPrice: { ...state.hotelPrice, lower: value.value.lower, upper: value.value.upper } });
    }
    const hotelFilterParentCallback = () => {
        item.hotelFilterParentCallback(state);
    }
    const onConfirmModal = () => {
        hotelFilterParentCallback();
        setState({ ...state, showHotelFilterModal: false });
    }
    const onOpenModal = () => {
        setLoading(true);
        setTimeout(() => {
            setState({ ...state, showHotelFilterModal: true });
        }, 200);
    }
    const handleCodeCallback = (childData: any) => {
        item.codeParentCallback(childData);
        setState({ ...state, showHotelFilterModal: false });
    }
    return (
        <div>
            {!loading ?
                <IonModal isOpen={state.showHotelFilterModal} onDidDismiss={() => setState({ ...state, showHotelFilterModal: false })} mode="ios" cssClass="hotel-filter-modal">
                    <div className="hotel-filter-modal-content">
                        <h3 className="hotel-filter-modal-title">
                            فیلتر نتایج
                            <IonIcon icon={close} onClick={() => setState({ ...state, showHotelFilterModal: false })} />
                        </h3>
                        <div className="hotel-filter-modal-items">
                            <div className="hotel-filter-modal-map">
                                <IonImg src={hotelFilterMap} />
                                <HotelMap data={mapData.current} codeParentCallback={handleCodeCallback} />
                            </div>
                            <div className="hotel-filter-modal-box box-search">
                                <span className="my-title">
                                    نام هتل
                                </span>
                                <div className="hotel-filter-modal-search-input">
                                    <IonInput type="text" onIonChange={e => setState({ ...state, searchKeyword: e.detail.value! })} placeholder="نام هتل را وارد کنید..." />
                                    <IonButton color="warning" onClick={onConfirmModal}>جستجو</IonButton>
                                </div>
                            </div>
                            {item.type !== 'flightHotel' &&
                                <div className="hotel-filter-modal-box box-price">
                                    <span className="my-title">
                                        قیمت هتل
                                    </span>
                                    <IonRange
                                        id="priceRange"
                                        min={state.hotelPrice.min}
                                        max={state.hotelPrice.max}
                                        dualKnobs
                                        color="warning"
                                        dir="ltr"
                                        onIonChange={e => setRangeSlider(e.target as any)}
                                    >
                                        <IonLabel slot="start" className="range-label-start">
                                            <CurrencyFormat value={state.hotelPrice.lower} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                        </IonLabel>
                                        <IonLabel slot="end" className="range-label-end">
                                            <CurrencyFormat value={state.hotelPrice.upper} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                        </IonLabel>
                                    </IonRange>
                                </div>
                            }
                            <div className="hotel-filter-modal-box box-star">
                                <span className="my-title">
                                    ستاره هتل
                                </span>
                                <div>
                                    <IonLabel onClick={() => checkAll('hotel-stars-checkbox')}>انتخاب همه</IonLabel>
                                    /
                                    <IonLabel onClick={() => unCheckAll('hotel-stars-checkbox')}>لغو انتخاب همه</IonLabel>
                                </div>
                                <IonList lines="none" className="hotel-stars-checkbox">
                                    {state.hotelRate.map((item: any, index: number) =>
                                        <IonItem lines="none" key={'index' + index}>
                                            <span>
                                                <IonCheckbox color="warning" value={item.value} checked={item.checked} onIonChange={(e) => checkCheckbox(index, e.detail.checked)} />
                                                {item.value} ستاره
                                            </span>
                                            <span className="star">
                                                {[...Array(item.value)].map((itemStar, indexStar) =>
                                                    <IonIcon icon={star} color="warning" key={'indexStar' + indexStar} />
                                                )}
                                            </span>
                                        </IonItem>
                                    )}
                                </IonList>
                            </div>
                        </div>
                    </div>
                    <div className="hotel-filter-modal-footer-btns">
                        <IonButton color="primary" className="hotel-filter-modal-confirm-btn" onClick={onConfirmModal}>تایید</IonButton>
                        <IonButton color="warning" onClick={() => setState({ ...state, showHotelFilterModal: false })} className="hotel-filter-modal-close-btn">بستن</IonButton>
                    </div>
                </IonModal>
                :
                <Loading />
            }
            <span onClick={onOpenModal} className={item.disabled ? 'disabled' : ''}>
                <IonIcon icon={filterImg} />
                فیلتر
            </span>
        </div>
    );
};
export default HotelFilter;